import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Footer() {
  return <footer className="bg-background-dark text-foreground-dark py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12">
          {}
          <div className="md:col-span-4">
            <Link to="/" className="inline-block mb-4">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/website_logo_zi.png" alt="ZI Logo" className="h-10 w-auto" />
            </Link>
            <p className="text-foreground-dark/80 text-sm leading-relaxed">
              Formamos estudiantes en los temas relacionados a la bolsa de
              valores del mercado estadounidense con instrucción experta y
              enfoque práctico.
            </p>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="text-lg font-semibold mb-4">Contacto</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="size-4 mt-0.5 shrink-0 text-accent" />
                <span className="text-sm text-foreground-dark/80">
                  Pine tree AV 742, Orlando, Florida
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-accent" />
                <Link to="tel:+15551234567" className="text-sm text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-fast)]"><span style={{
                  color: 'rgb(255, 255, 255)',
                  backgroundColor: 'oklab(0.999994 0.0000455678 0.0000200868 / 0.1)'
                }}>321-247-1391</span></Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-accent" />
                <Link to="mailto:contacto@zafiroinvestment.com" className="text-sm text-foreground-dark/80 hover:text-accent transition-colors duration-[var(--duration-fast)]">
                  contacto@zafiroinvestment.com
                </Link>
              </div>
            </div>
            <div className="mt-4 text-sm text-foreground-dark/80">
              <p className="font-medium">Horario:</p>
              <p>Lunes a Viernes: 9am - 4pm</p>
            </div>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="text-lg font-semibold mb-4">Síguenos</h3>
            <div className="flex gap-4">
              <Link to="https://facebook.com" newTab className="size-10 rounded-md bg-foreground-dark/10 hover:bg-primary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 focus-ring" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://twitter.com" newTab className="size-10 rounded-md bg-foreground-dark/10 hover:bg-primary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 focus-ring" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="https://instagram.com" newTab className="size-10 rounded-md bg-foreground-dark/10 hover:bg-primary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 focus-ring" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
              <Link to="https://linkedin.com" newTab className="size-10 rounded-md bg-foreground-dark/10 hover:bg-primary flex items-center justify-center transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 focus-ring" aria-label="LinkedIn">
                <Linkedin className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-foreground-dark/20 text-center">
          <p className="text-sm text-foreground-dark/60">
            © 2025 Zafiro Investments. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}